import ResetPasswordForm from './ResetPasswordFormContainer';

export default ResetPasswordForm;
